import React from "react";
import styled from "styled-components";
import {
  AM_TIME_SLOTS,
  PM_TIME_SLOTS,
} from "../../../helpers/timeSlotConstants";

const TimeSlotSelector = ({ selectedSlots = [], setSelectedSlots }) => {
  const toggleSlot = (slot) => {
    if (selectedSlots.includes(slot)) {
      setSelectedSlots(selectedSlots.filter((s) => s !== slot));
    } else {
      setSelectedSlots([...selectedSlots, slot]);
    }
  };

  const renderRow = (slots) => (
    <TimeWrapper>
      {slots.map((slot) => (
        <TimeSlotButton
          key={slot}
          type="button"
          active={selectedSlots.includes(slot)}
          onClick={() => toggleSlot(slot)}
        >
          {slot}
        </TimeSlotButton>
      ))}
    </TimeWrapper>
  );

  return (
    <RowsWrapper>
      {renderRow(AM_TIME_SLOTS)}
      {renderRow(PM_TIME_SLOTS)}
    </RowsWrapper>
  );
};

export default TimeSlotSelector;

const RowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TimeWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 10px;
`;

const TimeSlotButton = styled.button`
  padding: 8px 16px;
  white-space: nowrap;
  border: ${({ active }) =>
    active ? "1px solid var(--themeColorSecondary)" : "1px solid var(--border)"};
  border-radius: 8px;
  background-color: "#fff";
  color: ${({ active }) =>
    active ? "var(--themeColorSecondary)" : "var(--text)"};
  font-weight: ${({ active }) => (active ? "bold" : "normal")};
  cursor: pointer;
  transition: all 0.2s ease;

  &:disabled {
    background-color: var(--bg);
    color: #888;
    cursor: not-allowed;
  }
`;
